class KeyValueCache {
  constructor() {
    this._internalCache = {};
  }

  get(theKey, defaultValue) {
    return this._internalCache[theKey] || defaultValue;
  }

  set(theKey, value) {
    if (!theKey) return value;

    if (typeof theKey === 'object') {
      for (var k in theKey) {
        if (k) {
          this._internalCache[k] = theKey[k];
        }
      }

      return;
    }

    this._internalCache[theKey] = value;
    return value;
  }
}

export {
  KeyValueCache as
  default
};
